/* eslint-disable import/no-extraneous-dependencies */
import { createAction } from 'redux-actions';

export const getDeliveryRouteRequestReceiptRequest = createAction('GET_LIST_DELIVERY_ROUTE_REQUEST_RECEIPT_REQUEST');
export const getDeliveryRouteRequestReceiptSuccess = createAction('GET_LIST_DELIVERY_ROUTE_REQUEST_RECEIPT_SUCCESS');
export const getDeliveryRouteRequestReceiptFailure = createAction('GET_LIST_DELIVERY_ROUTE_REQUEST_RECEIPT_FAILURE');

export const updateStatusDeliveryRouteRequestReceiptRequest = createAction('UPDATE_STATUS_DELIVERY_ROUTE_REQUEST_RECEIPT_REQUEST');
export const updateStatusDeliveryRouteRequestReceiptSuccess = createAction('UPDATE_STATUS_DELIVERY_ROUTE_REQUEST_RECEIPT_SUCCESS');
export const updateStatusDeliveryRouteRequestReceiptFailure = createAction('UPDATE_STATUS_DELIVERY_ROUTE_REQUEST_RECEIPT_FAILURE');
export const resetUpdateStatusDeliveryRouteRequestReceiptState = createAction('RESET_UPDATE_STATUS_DELIVERY_ROUTE_REQUEST_RECEIPT_STATE');

export const resetDeliveryRouteRequestReceiptState = createAction('RESET_DELIVERY_ROUTE_REQUEST_RECEIPT_STATE');
